<template>
  <div class="wrap_wrap">

    <!-- 移动端分享遮罩 -->
    <div v-show="share_mask_state" class="mask" >
      <div class="modal">
        <img src="../assets/img/share_img.png" alt="点击右上角分享">
        <div class="close" @click="share_mask_state = 0">
          <!-- <img src="./../assets/img/close_btn.png" alt="关闭"> -->
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div v-if="isMobile" id="mobile">
      <div class="content">
        <div class="top">
          <div class="mobile_logo">
            <img src="../assets/img/mobile_logo.png" alt="">
          </div>
          <div class="mobile_dianzan">
            <img src="../assets/img/mobile_dianzan.png" alt="">
          </div>
        </div>
        <div class="middle">
          <div class="work_video">
            <video  :src="video_url"   controls="controls">
            your browser does not support the video tag
            </video>
          </div>
          <!-- m作品用户详情 -->
          <div class="work_user_detail">
            <div class="work_user_logo"><img :src="work_uesr_avatar" alt=""></div>

            <div class="work_uesr_name">{{work_uesr_name}}</div>
            <div class="work_detail_mobile">这是我的编程作品《{{work_title_half}}》，快来给我点赞吧！</div>
          </div>
          <!-- m点赞 -->
          <div class="dianzan" @click="dianzan_add">
            <div v-show="!dianzan" class="dianzan_btn" > <img src="../assets/img/dianzan_w.png" alt="点赞"><span>{{dianzan_num}} </span></div>
            <div v-show="dianzan" class="dianzan_btn"> <img src="../assets/img/dianzan_y.png" alt="点赞"><span>{{dianzan_num}}</span></div>


          </div>
          <!-- m作品介绍 -->
          <div class="work_about">
            <div class="work_about_position_wrap">
              <div class="work_about_logo"><img src="./../assets/img/work_about.png" alt=""></div>
              <span class="work_about_title">作品介绍</span>
              <div class="line"></div>
            </div>
            <div class="work_about_text">
              <span> {{work_about_text}}</span>
            </div>
            <img src="../assets/img/mobile_bg.png" alt="">
          </div>
          <!-- m老师点评 -->
          <div class="work_teacher_say work_about">
            <div class="work_about_position_wrap">
              <div class="work_about_logo"><img src="./../assets/img/teacher_say.png" alt=""></div>
            <span class="work_about_title">老师点评</span>
            <div class="line"></div>
            </div>
            <div class="work_about_text">
              <span>{{work_teacher_say}}</span>
            </div>
            <img src="../assets/img/mobile_bg.png" alt="">
          </div>
        </div>
        <!-- 广告 -->
        <div v-if="share" class="ad bottom_fixed" >
          <div class="ad_name">
            {{ad_name}}
          </div>
          <div class="ad_money">
            <!-- <div class="only">仅需</div> -->
            <div class="only">原价399元</div>
            <!-- <div class="cny">¥</div> -->
            <div class="how_much">
              {{how_much}}
            </div>
          </div>
          <div class="buy_now" @click="go_purchase_page"><span> 立即领取</span></div>
        </div>

        <div v-if="share" class="ad" >
          <!-- 广告占位20vw -->
        </div>

        <!-- 分享!share  点击调用分享函数弹出图片遮罩-->
        <div v-if="!share" class="share_text bottom_fixed" @click="share_mask_show">
          <img src="../assets/img/share_logo.png" alt="">
          <span>分享作品，让别人为你点赞吧！</span>
        </div>
        <!-- 分享占位 -->
        <div v-if="!share" class="share_text">
          <!-- 15vw -->
        </div>
        <!-- 悬浮 -->
        <!-- <div class="bottom_fixed">
          xxx
          <a href="https://www.baidu.com/" rel="nofollow" target="_blank"><img src="https://www.baidu.com/s?wd=ffmpeg&usm=1&ie=utf-8&rsv_cq=merge+git&rsv_dl=0_right_recommends_merge_28335&euri=856526"></a><div>X</div>
        </div> -->

      </div>
    </div>
    <!-- pc 背景 -->
    <div v-if="!isMobile"  class="wrap">
      <!-- pc端 -->
      <div class="pc">
        <div class="content">
          <div class="work_title">{{work_title}}</div>
          <!-- 根据角色显示点评 只有班主任显示 -->
          <div v-if="role_value === 'classmanager'" class="top_btn dianping" @click='commentHandler'><span>点评作业</span></div>
          <!-- <div v-if="role_value === 'guest'" class="top_btn dianping" @click='commentHandler'><span>点评作业</span></div> -->
          <!-- <div v-if="role_value === 'self'" class="top_btn dianping" @click='commentHandler'><span>点评作业</span></div> -->
          <div v-show="!dianzan" class="top_btn dianzan" @click="dianzan_add"><img src="../assets/img/dianzan_pc_w.png" alt=""><span class="dianzan_num_set">{{dianzan_num}}</span></div>
          <div v-show="dianzan" class="top_btn dianzan"><img src="../assets/img/dianzan_pc_y.png" alt=""><span class="dianzan_num_set">{{dianzan_num}}</span></div>
           <!-- <div v-show="dianzan" class="top_btn dianzan"><img src="../assets/img/dianzan_pc_y.png" alt=""><span >99</span></div> -->
          <!-- pc视频模块 -->
          <div class="work_video">
            <video width="427" height="320"  :src="video_url" controls="controls">
            your browser does not support the video tag
            </video>
          </div>
          <!-- pc作品用户详情 -->
          <div class="work_user_detail">
            <div class="work_user_logo"><img :src="work_uesr_avatar" alt=""></div>
            <div class="work_detail_pc">{{work_uesr_name}}的第<span>{{work_num}}</span>个作品</div>
            <div class="work_time">{{work_time}}</div>
            <div class="work_state">{{work_state}}</div>
          </div>
          <!-- pc作品介绍 -->
          <div class="work_about">
            <div class="work_about_logo"><img src="./../assets/img/work_about.png" alt=""></div>
            <span class="work_about_title">作品介绍</span>
            <div class="work_about_text">
              {{work_about_text}}
            </div>
          </div>
          <!-- pc老师点评 -->
          <div class="work_teacher_say">
            <div class="work_about_logo"><img src="./../assets/img/teacher_say.png" alt=""></div>
            <span class="work_about_title">老师点评</span>
            <div class="work_teacheer_say_text">
              {{work_teacher_say}}
            </div>
          </div>
          <!-- 二维码分享 -->
          <div class="work_qrcode_share">
            <div id="qrcode" ref="qrcode"></div>
              <span>扫码分享</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const MOOBILE_REG = /(nokia|iphone|android|ipad|motorola|^mot\-|softbank|foma|docomo|kddi|up\.browser|up\.link|htc|dopod|blazer|netfront|helio|hosin|huawei|novarra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam\-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte\-|longcos|pantech|gionee|^sie\-|portalmmm|jig\s browser|hiptop|^ucweb|^benq|haier|^lct|opera\s*mobi|opera\*mini|320x320|240x320|176x220)/i
  // const isMobile = MOOBILE_REG.test(window.navigator.userAgent)

  import Vue from 'vue'
  import QRCode from 'qrcodejs2'
  import { log } from 'util';
  // import logo from '../assets/def_icon.png'
export default {
  name:"work",
  data(){
    return {
      // 作业id
      work_id:null,

      allData:null,
      // 当前本机地址
      // url:"http://192.168.2.131:8085/#/works",
      // 课程标题
      work_title:"[1-2课接红包]",
      // 作业视频地址
      //video_url:'https://v-cdn.zjol.com.cn/276984.mp4',  //原测试视频url
      video_url:'https://cdn2.geek-8.com/geekmooc/media/upload_c91c8e5f068f69cdb906315107e87bd3.mp4',  //审核中视频url
      

      //  是否点赞过
      dianzan:0,
      // 当前点赞数
      dianzan_num:0,
      // 作品num
      work_num:1,

      // 是否是分享受众 0本人 1受众 self /guest
      share:0,
      // 是否教师打开 0学生 1老师  self/classmanager" teacher改为role_value,原share受众也用
      role_value:0,
      // 作业创建时间
      // work_time:"2020.01.27 12:20",
      work_time:"作业时间加载中",
      // 批改状态
      work_state:"批改中",
      work_uesr_name:'unknow',
      // 用户头像
      work_uesr_avatar:require('../assets/img/def_icon.png'),
      // 《悟空斗魔王》
      work_title_half:null,
      work_detail_mobile:'这是我的编程作品《悟空斗魔王》，快来给我点赞吧！',
      work_about_text:"暂无作品介绍",
      work_teacher_say:'暂无点评···',
      ad_name:'极客晨星4节少儿编程课',
      // how_much:"9.9",
      // how_much:"2.8",
      how_much:"免费领取",
      // 点赞token
      token:'',
      // 买课连接
      purchase:"",
      // 一定段分享页遮罩弹出状态 1弹出 0隐
      share_mask_state:0

    }
  },
  mounted() {
    var test =window.location.href;
  // var url_value_all=test.split("?")[1];
  // console.log(url_value_all,"所有url值");

  // 截取地址获取 work_id
  // this.work_id = url_value_all.split("=")[1].split("&")[0];

  this.work_id = this.$route.query.id;
  // 3.14微信分享 try
  if (this.$route.query.wxshared == '1') {
    window.location.href = `${location.origin}/portkey/scratchprojects/${this.work_id}`;
  }

    console.log(this.work_id+'传过来到id');
    // 请求数据
    this.getunit ()
    // 加载二维码
    this.createQrcode()
    


    // this.axios.get("/api/v1/api/self").then((res) => {
      // 2020.2.4修改接口 废弃self接口··········
    // this.axios.get("/v1/api/self").then((res) => {
    //     console.log(res.data.user);
    //     if (res.data.user.nickname = '') {
    //       // 昵称
    //       this.work_uesr_name = res.data.user.nickname
    //     }else{
    //       // 姓名
    //       this.work_uesr_name = res.data.user.name
    //     }
    //     // 头像
    //     this.work_uesr_avatar = res.data.user.avatar
    //     console.log(this.work_uesr_avatar);

    //     console.log("self接口数据获取昵称/头像/用户名");

    //   })
  },
  components: {

  },
  methods:{
    // 分享遮罩弹出
    share_mask_show(){
      // 修改遮罩显示
      this.share_mask_state = 1;
      // 调用微信分享？未跑通

      // urlSharedHandler ()
    },
    // 微信分享

    urlSharedHandler () {
      // var urlShared = `https://mooc.jikestar.com/moocpay?classtype=${this.classtype}#/recordf1-x-x`;
      //  var urlShared = "https://www.baidu.com/";

      // var urlShared = window.location.href;

      
      // // 3.13修改微信分享地址
      // var urlShared =  `${location.origin}/portkey/scratchprojects/${this.work_id}`;
      // // console.log(urlShared);
      
      // var urlEncoded = encodeURIComponent(urlShared);
      // var urlRequest = '/jssdkparams?userurl=' + urlEncoded;
      // //3.14增加history.pushState 
      // history.pushState(null, '作品详情', urlShared)

      // 3.14
      var urlShared = window.location.href + '&wxshared=1';
      var urlEncoded = encodeURIComponent(urlShared.split('#')[0]);
      var urlRequest = '/jssdkparams?userurl=' + urlEncoded;
      
      console.log('urlShared ' + urlShared);
      console.log('urlRequest ' + urlRequest);

      var xhr = new XMLHttpRequest();
      xhr.open('GET', urlRequest, true);
      var _this = this;
      xhr.onload = function () {
        if (xhr.status === 200) {
          var json = JSON.parse(xhr.response);
          // var urlImg = 'https://mars.geek-8.com/images/bcastpy.png';
          var urlImg = 'https://mooc.jikestar.com/geekmooc/images/share_preview.png';
          // var title =  `【${_this.activityname}】最后200名，极客晨星趣味编程课直降${_this.normalprice - _this.groupprice}元，再送8节！ \n`;
          var title = `${_this.work_uesr_name}同学的Scratch编程作品`;
          var wxdesc = '晒出孩子的学习成果，为孩子的成长助力。';
          // var wxdesc = `一年学会两年的编程课仅需${_this.groupprice}元，活动结束后恢复原价${_this.normalprice}元，手快有手慢无`;
          

          wx.config({
            debug: false,
            appId: json.appId,
            timestamp: json.timestamp,
            nonceStr: json.nonceStr,
            signature: json.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
          });

          wx.ready(function () {
            wx.onMenuShareTimeline({
              title: title + ':' + wxdesc,
              link: urlShared,
              imgUrl: urlImg,
              success: function () {
                console.log(123);
              },
              cancel: function () {}
            });

            wx.onMenuShareAppMessage({
              title: title,
              desc: wxdesc,
              link: urlShared,
              imgUrl: urlImg,
              type: '',
              dataUrl: '',
              success: function () {
                console.log(456);
              },
              cancel: function () {}
            });
          });
        }
      };
      xhr.send(null);
    },

    commentHandler () {
      window.open(`/projects/${this.work_id}?openid=${this.$route.query.openid}`);
    },
    getunit () {
      let url = '';
      console.log('this.$route.query.openid',this.$route.query.openid)
      if(this.$route.query.openid){
        url = `/v1/api/scratch/projects/${this.work_id}?openid=${this.$route.query.openid}`
      }else{
        url = `/v1/api/scratch/projects/${this.work_id}`
      }
      this.axios.get(url)
      .then((res) => {
        // console.log(res);
        this.allData = res.data.project
        this.token = res.data.token
        // 将购课链接
        // this.purchase = res.data.purchase
        //this.purchase = "https://mooc.jikestar.com/moocpay1/hj1/bcastpy0-1/index.html"; //写死的9.9
        // this.purchase = "https://mooc.jikestar.com/moocpay1/bdhz/bcastpy0-1/index.html"; //新的2.8链接
        this.purchase = "https://mooc.jikestar.com/moocpay1/bdhzfree/bcastpy0-1/index.html?utm_source=zuopin"; //新的2.8链接
        console.log(res.data.token,'点赞token');
        console.log(res.data.purchase,'购课链接');
        console.log(res,'请求回来的数据');
        console.log(this.allData);

        

        console.log(res.data.user);
        // if (res.data.user.nickname = ''|undefined|"undefined") {
        //   // 昵称
        //   this.work_uesr_name = res.data.user.nickname
        // }else{
        //   // 姓名
        //   this.work_uesr_name = res.data.user.name
        // }
        // 姓名
        if (res.data.user.name) {
          // 接口获取姓名
          this.work_uesr_name = res.data.user.name
           // 微信分享
          this.urlSharedHandler()
        }else{
          this.work_uesr_name = "unknown"
           // 微信分享
          this.urlSharedHandler()
        }

        // 头像
        if (res.data.user.avatar) {
          this.work_uesr_avatar = res.data.user.avatar
          console.log(res.data.user.avatar," 获取221");
        }else{
          // this.work_uesr_avatar ='https://oss1.geek-8.com/users/5e17037d81b30f000f6071c2/avatar.png'
          // 默认头像先出现 data中有
          // this.work_uesr_avatar = require('../assets/img/def_icon.png')
          console.log("头像无数据使用默认头像");


        }

        console.log(this.work_uesr_avatar," 最终头像221");

        // console.log("替换self接口数据获取昵称/头像/用户名");
        // 作品详情
        this.work_about_text = this.allData.scratch.description;
        // 获取当前角色 role值 self/guest/classmanager"
        // this.teacher = res.data.role;

        if (res.data.role == "self") {
          // 默认0  0不显示广告显示分享 
          this.share = 0
          // this.share = 1
        }else{
          // 默认1 显示 9.9 不显示分享
          // this.share = 0
          this.share = 1
        }
        this.role_value = res.data.role;
        console.log(this.role_value,'role身份');
        
        // this.allData.scratch.remark= '老师测试评语'

        // 老师点评
        if (this.allData.scratch.remark=="") {
          // this.work_teacher_say = '暂无数据t'
              console.log("老师点评无数据",this.work_state,"批改状态");
              // 使用默认数据 无需操作
        }else{
              console.log(this.allData.scratch.remark,"老师点评有数据",this.work_state,"批改状态");
              this.work_state = "已批改"
          // 数据覆盖默认数据
          this.work_teacher_say = this.allData.scratch.remark
        }
        console.log("点评"+this.allData.scratch.remark!="");
        // this.work_teacher_say = this.allData.scratch.remark

        console.log(this.allData.scratch.upvote,"点赞数字");
        let dz= this.allData.scratch.upvote
        // let dz = 9999
        console.log(dz,'dz');

        // 点赞数
        if (dz == 0) {
          console.log("点赞为0");
          this.dianzan_num = '点赞'
        }else if(dz >=9999){
          this.dianzan_num = '9999+'
        }else{
          this.dianzan_num = dz
          console.log(this.dianzan_num,'dainzanz_num点赞数');
        }

        // this.dianzan_num = this.allData.scratch.upvote

        this.work_num = this.allData.scratch.number

        // 作品标题
        this.work_title = this.allData.scratch.title

        this.work_title_half = this.allData.scratch.title.split("/")[1];
        //视频地址
        this.video_url = this.allData.video
        // 作业创建时间
        // this.work_time =  this.allData.createAt
        //
        // console.log(this.work_time);
        var formatDateTime = function (date) {
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                m = m < 10 ? ('0' + m) : m;
                var d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                var h = date.getHours();
                h=h < 10 ? ('0' + h) : h;
                var minute = date.getMinutes();
                minute = minute < 10 ? ('0' + minute) : minute;
                var second=date.getSeconds();
                second=second < 10 ? ('0' + second) : second;
                return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
            };

        this.work_time = formatDateTime(new Date(this.allData.createAt))
        // console.log(new Date(this.work_time));
        // console.log(formatDateTime(Date(this.allData.createAt)) );


        // console.log(this.unitData.length);
        // return res
        // this.$router.push('/')
      }).catch((error) => {
        if (error.response) {
          // 失败
          this.$message.error('获取数据失败')
          let data = error.response.data
          this.errorMessage = data.error.message
        }
      })
    },
    getDianzan (id,_token) {
      this.axios.post("/v1/api/scratch/projects/"+id+"/upvote", {
        token:_token
      }).then((res) => {
        console.log(res,'点赞接口数据',_token,"token");
        this.dianzan = 1
        // 无点赞 点赞
        if (this.dianzan_num == '点赞') {
          console.log('文字点赞');

          // 点赞数字为1
          this.dianzan_num  = 1
        }else if(this.dianzan_num =='9999+'){
          // 点赞增加
          console.log('9999+',this.dianzan_num);
        }else{
          // 点赞增加
          console.log('增加前',this.dianzan_num);

          this.dianzan_num++
        }

      }).catch((error) => {
        if (error.response) {
          this.dianzan = 0
          // 失败
          this.$message.error('获取数据失败')
          let data = error.response.data
          this.errorMessage = data.error.message
        }
      })
    },
    createQrcode () {
        if (this.isMobile) {
          console.log("移动设备停止二维码创建");
          return
        }

        // this.url = window.location.protocol+"//"+window.location.host+"/work#/works?id="+this.work_id
        // console.log(url);
        console.log('window.location.href');
        console.log(window.location.href);


        document.getElementById('qrcode').innerHTML = ''
        // 21.1.5
        let qrtext = `${location.origin}/portkey/scratchprojects/${this.work_id}`;
        let qrcode = new QRCode('qrcode', {
            // text:window.location.href,
            text:qrtext,
            
            // text:window.location.protocol+"//"+window.location.host+"/work#/works?id="+this.work_id,
            width: 133, //图像宽度
            height: 133, //图像高度
            colorDark : "#000000", //前景色
            colorLight : "#ffffff", //背景色
            typeNumber:4,
            correctLevel : QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        })
        // qrcode.clear() //清除二维码
        // qrcode.makeCode(url) //生成另一个新的二维码
    },
    // 点赞
    dianzan_add(){
      if (this.dianzan) {
        return
      }
      // this.dianzan = 1

      // this.dianzan_num++
      //  调用点赞接口
      this.getDianzan(this.work_id,this.token)

    },
    // 跳转买课连接
    go_purchase_page(){
      window.location.href=this.purchase
    }

  },
  computed:{
    isMobile (){
      console.log("是否手机"+MOOBILE_REG.test(window.navigator.userAgent) )
      return MOOBILE_REG.test(window.navigator.userAgent)
    }
  }
}
</script>


<style lang="stylus" scoped>

// 移动端m
#mobile{
    width 100vw
    background:linear-gradient(135deg,rgba(255,209,39,1) 0%,rgba(244,130,17,1) 100%);
    min-height 100vh
    margin 0 auto
    // 移动端内容m
    .content{

      // 顶部m
      .top{
        position relative

        .mobile_logo{
          img{
            width 35vw
          }


        }
        .mobile_dianzan{
          width  24vw
          // background #000
          position absolute
          top 3.5vw
          left 72vw
          img{
            width 24vw
          }

        }
      }
      // 外部尺寸m
      .work_video{
        margin  2vw auto
        width 92vw
        height 69vw
        // 移动端视频尺寸m
        video{
          // margin 2vw auto
          width 92vw
          height 69vw
          border-radius:3vw;
        }
      }
      // 作品m作者详情work_user_detail
      .work_user_detail{
        position relative
        margin-top 5vw
        width 92vw
        min-height 13vw
        margin  0 auto


        img {
          width 12vw
          position absolute
          left 1vw
          border-radius: 50%;

        }
        .work_uesr_name{
          font-size 4vw;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(255,255,255,1);
          line-height:5vw;
          position absolute
          left 15vw
          top 1vw

        }
        .work_detail_mobile{
          font-size:3.5vw;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(255,255,255,1);
          line-height:4vw;
          position absolute
          left 15vw
          top 7vw

        }

      }
      // 点赞m
      .dianzan{

        width 92vw
        min-height 12vw
        position relative
        margin  5vw auto 0
        background:rgba(255,228,100,1);
        box-shadow:0px 0px 1px 0px rgba(214,131,2,0.5);
        border-radius:6vw;
        font-size:4vw;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(236,120,0,1);
        line-height:6vw;
        .dianzan_btn{
          position absolute
          left 38vw
          top 3vw
          img{
            width 5vw

          }
          span{
            min-width 9vw
            min-height 6vw
            position absolute
            left 7vw
            top 0vw
            font-size:4vw;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(236,120,0,1);
            line-height:6vw;
          }
        }
      }
      // 作品介绍m
      .work_about{
        background-color white
        border-radius 3vw

        width 96vw
        min-height 28vw
        // position relative
        margin  4vw auto
        // 定位容器
        .work_about_position_wrap{
          position relative
          // 小logo
          .work_about_logo{
            img{
              width 6vw
              position absolute
              left 7vw
              top 5vw
              // margin-top 5.5vw
              // margin-left 7vw
              line-height:5vw;
              inlineblock block
            }
          }
          // 文字标题
          .work_about_title{
            position absolute
            left 13vw
            top 6vw
            // margin-left 13vw
            // margin-top 6vw
            // background #000
            min-width 15vw
            font-size:4vw;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(247,167,0,1);
            line-height:5vw;

          }
          // 分割线
          .line{
            width:81vw;
            border:1px solid rgba(247,167,0,1);
            position absolute
            left 7vw
            top 14vw

          }

        }

        img{
          margin-top 1vw
          width 96vw
        }


        .work_about_text{
          // position absolute
          // left 7vw
          // top 16vw
          width:83vw;
          // min-height:33vw;
          // margin 14vw 4vw 16vw 4vw
          margin 0 4vw
          padding-top 16vw
          padding-left 3vw
          font-size:3.5vw;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,87,87,1);
          line-height:5vw;
        }

      }
      // 分享m
      .share_text{
        width:100vw;
        height:15vw;
        background:rgba(255,247,210,1);
        // position relative
        img{
          width 5vw
          height 4vw
          position absolute
          top 5vw
          left 18vw
          line-height 6vw
        }
        span{
          min-width:56vw;
          min-height:6vw;
          font-size:4vw;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(212,111,0,1);
          line-height:6vw;
          position absolute
          top 5vw
          left 26vw
        }
      }
      // 广告m
      .ad{
        width:100vw;
        height:20vw;
        background:rgba(255,247,210,1);
        // position relative
        // 底部悬浮bottom_fixed中设置
        // position:fixed
        // bottom:0px;
        // z-index:9999

        .ad_name{
          min-width:42vw;
          height:6vw;
          font-size:4vw;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(212,111,0,1);
          line-height:6vw;
          position absolute
          top 3vw
          left 7vw
        }
        .only{
          min-width:6vw;
          min-height:4vw;
          font-size:3vw;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(212,111,0,1);
          line-height:4vw;
          position absolute
          top 13vw
          left 7vw
          // 划线 
          text-decoration: line-through;
        }
        .cny{
          width:6vw;
          height:4vw;
          font-size:5vw;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(212,111,0,1);
          line-height:4vw;
          position absolute
          top 12vw
          left 15vw
        }
        .how_much{
          width:12vw;
          height:11vw;
          font-size:8vw;
          
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
          color:rgba(212,111,0,1);
          line-height:11vw;
          position absolute
          top 8vw
          left 20vw

          // 免费领取 修改
          width: 34vw;
          height: 11vw;
          font-size: 6vw;
          font-family: PingFangSC-Semibold,PingFang SC;
          font-weight: 600;
          color: #d46f00;
          line-height: 11vw;
          position: absolute;
          top: 8vw;
          left: 26vw;
        }
        .buy_now{
          width:26vw;
          height:9vw;
          background:rgba(237,124,0,1);
          border-radius:5vw;
          position absolute
          top 5vw
          left 68vw
          // margin 0 auto
          span{
            width:16vw;
            margin 0 0 0 auto
            // height:9vw;
            font-size:4vw;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(255,243,186,1);
            line-height:9vw;
            position relative

            left 4vw
          }
        }
      }

    }
  }


// 外部容器 背景

.wrap{
  background:#E5FFED
  // background-image: url(../assets/img/bgtest.png)
  // background:url(../assets/img/bgtest.png) left top no-repeat;
  background-size: 100% 100%;
  height 100vh
  overflow hidden
  display flex
  overflow hidden
  // 最小宽度
  min-width 922px
  display: flex;
	align-items: center;
	justify-content: center;

  // pc端ui
  .pc{
    margin 0 auto
    // align-self center
    position relative
    // 内容容器p
    .content{
      width:870px;
      height:593px;
      background:rgba(255,229,132,1);
      border-radius:16px;
      // 课程标题title 例如1-2课 接红包
      .work_title{
        font-size:24px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(85,85,85,1);
        line-height:33px;
        position absolute
        top 28px
        left 29px
      }
      // 视频pc
      .work_video{
        width:428px;
        height:296px;
        background gary

        border-radius:17px;
        position absolute
        left 22px
        top 88px
        video{
          border:none;
          background-color:transparent;
          outline:none;
          border-radius:17px;
        }


      }
      // 点评作业点赞按钮样式pc
      .top_btn{
        cursor:pointer;
        width:132px;
        height:50px;
        background:rgba(255,143,0,1);
        border-radius:25px;
        position absolute
        top 21px
        text-align center
        cursor:pointer;



        // span{
        //   width:50px;
        //   height:50px;
        //   font-size:21px;
        //   font-family:PingFangSC-Medium,PingFang SC;
        //   font-weight:500;
        //   color:rgba(255,255,255,1);
        //   line-height:50px;

        // }
      }

      .dianping{
        position absolute

        left 546px
        span{
          height:50px;
          font-size:21px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(255,255,255,1);
          line-height:50px;
        }

      }
      .dianzan{

        position absolute
        cursor:pointer;
        left 698px
        img{
          width 27px
          height 28px
          position absolute
          left 27px
          top 11px
        }
        span{
          width:50px;
          height:50px;
          position absolute
          left 62px
          cursor:pointer;
          text-align center
        }

      }
      //  作品用户详情pc
      .work_user_detail{
        width:385px;
        height:99px;
        background:rgba(255,255,255,1);
        border-radius:11px;
        border:1px solid rgba(255,143,0,1);
        position absolute
        top 88px
        left 463px
        img {
          width 66px
          height 66px
          position absolute
          top 18px
          left 16px
          border-radius: 50%;
        }
        // pc谁的第几个作品
        .work_detail_pc{
          font-size:18px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,87,87,1);
          line-height:26px;
          position absolute
          top 25px
          left 93px
          text-align center
          span {
            color #00AEE1
          }
        }
        //  作业时间pc
        .work_time{
          font-size:16px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,87,87,1);
          line-height:22px;
          position absolute
          top 55px
          left 93px
          text-align center
        }
        // 批改pc
        .work_state{
          width:78px;
          height:37px;
          border-radius:23px;
          border:1px solid rgba(247,167,0,1);
          font-size:16px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(247,167,0,1);
          line-height:37px;
          position absolute
          top 32px
          left 290px
          text-align center
        }

      }
      //  作品介绍pc
      .work_about{
        width:385px;
        height:208px;
        background:rgba(255,255,255,1);
        border-radius:11px;
        border:1px solid rgba(255,143,0,1);
        position absolute
        top 200px
        left 463px
        .work_about_logo{
          // background #000
          position absolute
          left 19px
          top 21px
        }
        // 作品介绍图片
        img{
          width 25px
          // height 20px

        }
        span{
          position absolute
          left 49px
          top 20px
        }

        .work_about_text{
          width:348px;
          height:108px;
          font-size:16px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,87,87,1);
          line-height:27px;
          position absolute
          left 19px
          top 57px
        }

      }
      // 通用样式
      .work_about_title{
          font-size:18px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(247,167,0,1);
          line-height:26px;
        }
      // 老师点评
      .work_teacher_say{
        width:827px;
        height:151px;
        background:rgba(255,255,255,1);
        border-radius:11px;
        border:1px solid rgba(255,143,0,1);
        position absolute
        top 420px
        left 22px
        span{
          position absolute
          left 52px
          top 17px
        }
        img{
          width 24px
          // height 25px
          position absolute
          left 22px
          top 18px
        }
        .work_teacheer_say_text{
          width:775px;
          height:108px;
          font-size:16px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,87,87,1);
          line-height:27px;
          position absolute
          left 24px
          top 52px
        }
      }

      // 二维码分享
      .work_qrcode_share{
        width:152px;
        height:181px;
        background:rgba(255,255,255,1);
        border-radius:8px;
        border:2px solid rgba(255,229,132,1);
        position absolute
        left -172px
        top 275px
        #qrcode{
          width:133px;
          height:133px;
          // background:rgba(216,216,216,1);
          margin 9px
        }
        span {
          font-size:17px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(94,94,94,1);
          line-height:24px;
          position absolute
          top 150px
          left 42px
        }

      }

    }
  }
}
.top_btn{
  cursor:pointer;
  z-index 99
}
.dianzan_num_set{
  width:50px;
  height:50px;
  font-size:21px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:50px;
}
// 底部悬浮

.bottom_fixed{
  position:fixed;
  bottom:0px;
  z-index:9999;
  .bottom_fixed_div{
    width:30px;
    height:30px;
    text-align:center;
    line-height:30px;
    background:#CCC;
    right:0;
    top:-30px;
    position:absolute;
    cursor:pointer;}
  }
  // 分享界面 背景遮罩
  .mask{
    position: fixed;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.5);
    display: flex;
    // align-items: center;
    // justify-content: center;
    z-index 9999
    .close{
      width: 100%;
      height: 100%;
      min-height: 100vh;

    }
  }
  // 分享弹窗
  .mask .modal{
    position absolute
    left 0
    top 0
    width: 100%;
    img{
      position absolute
      right 0
      width 80%
    //  width 100%
    }
    // height: 356px;
    // background-image: url(../assets/img/share_view.png)
    // background-size: 100% 100%;




  }


</style>
